import React from 'react'
import DashboardLayout from '../../admin-component/layout/dashboardLayout';
import WalletList from './list';

const WalletHistoryList = () => {
    return (
        <DashboardLayout>
            <WalletList />
        </DashboardLayout>
    );
};
export default WalletHistoryList;